import * as Yup from "yup";
import { splitDateStringToParts } from "../../../util/date";
import { getPatchOperations } from "../../../util/form";

export const personGennemfoerteTilsynForm = (
  personId: string,
  personTilsynId: string | undefined,
): FormConfig<PersonGennemfoerteTilsynDTO> => {
  return {
    title: "gennemført tilsyn",
    lockedValues: [
      {
        id: "personId",
        value: personId,
      },
      {
        id: "personTilsynId",
        value: personTilsynId,
      },
    ],
    validationSchema: Yup.object({
      gennemfoerselDato: Yup.string()
        .required("Kvartal skal være sat")
        .test("gennemfoerselDato", "Årstal skal være sat", (item) => {
          if (item) {
            const parts = splitDateStringToParts(item);
            const [yearPart] = parts;
            return yearPart !== "0000";
          }
          return !!item;
        })
        .test("gennemfoerselDato", "Årstal skal være højere", (item) => {
          if (item) {
            const parts = splitDateStringToParts(item);
            const [yearPart] = parts;
            return yearPart > "1899";
          }
          return false;
        }),
      personTilsynstype: Yup.string().required("Tilsynstype skal være sat"),
      sagsNr: Yup.string().max(10, "Sagsnummer må ikke være mere end 10 tegn"),
      bemaerkning: Yup.string(),
      udtagetDato: Yup.date().nullable(),
    }),
    form: [
      {
        component: "kvartal",
        id: "gennemfoerselDato",
        label: "Gennemført",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "kode-select",
        kodeListeType: "PersonTilsynstypeKode",
        id: "personTilsynstype",
        label: "Type",
        placeholder: "Vælg type",
        initialValue: "",
        isRequired: true,
      },
      {
        component: "textinput",
        id: "sagsNr",
        label: "Sagsnr. F2",
        initialValue: "",
      },
      {
        component: "textarea",
        id: "bemaerkning",
        label: "Bemærkning",
        initialValue: "",
      },
    ],
    get: `person/${personId}/tilsyn/${personTilsynId}`,
    patch(values: PersonGennemfoerteTilsynDTO) {
      return {
        query: `person/${personId}/tilsyn/${personTilsynId}`,
        body: JSON.stringify(getPatchOperations(values)),
      };
    },
    post(values: PersonGennemfoerteTilsynDTO) {
      const { bemaerkning, gennemfoerselDato, sagsNr, personTilsynstype } =
        values;
      return {
        query: `person/${personId}/tilsyn/`,
        body: {
          gennemfoerselDato,
          sagsNr,
          bemaerkning,
          personTilsynstype,
        },
      };
    },
    delete() {
      return {
        query: `person/${personId}/tilsyn/${personTilsynId}`,
      };
    },
  };
};
